<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [items]="[
          { label: 'RECETAS', link: '/prescription/prescription-list' },
          { label: isEditMode ? 'ACTUALIZAR RECETA' : 'NUEVA RECETA' }
        ]">
      </app-breadcrumb>

    </div>

    <mat-accordion>

      <!-- Paciente -->
      <mat-expansion-panel #panelPaciente="matExpansionPanel" [expanded]="true" data-tour="rx-panel-paciente">
        <mat-expansion-panel-header>
          <mat-panel-title>
            DATOS DEL PACIENTE<span *ngIf="isPatientLoaded" style="color: #00a5b8">: {{ patient.nombres }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Buscador de paciente -->
        @if (!isPatientLoaded) {
          <div class="row">
            <div class="col-lg-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>Ingrese el nombre del paciente</mat-label>
                <input
                  autocomplete="off"
                  aria-autocomplete="none"
                  (ngModelChange)="searchPatientsByKeyPress()"
                  (focus)="clearPatients()"
                  (click)="clearPatients()"
                  [(ngModel)]="searchPatients"
                  [matAutocomplete]="autoPatients"
                  matInput
                  appUppercaseNoAccent
                  name="patients"
                  type="text"
                  data-tour="rx-patient-search"
                />
                <mat-autocomplete
                  #autoPatients="matAutocomplete"
                  (optionSelected)="setSelectedPatient($event.option.value)"
                  [displayWith]="displayFnPatients"
                >
                  @for (option of patients; track option) {
                    <mat-option [value]="option">
                      {{ option.nombres + ' ' + option.primerApellido + ' ' + option.segundoApellido }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        }
        <!-- Datos cargados del paciente -->
        @if (isPatientLoaded) {
          <div class="rx-clinical-summary">

            <div class="rx-summary-header">
              <div class="rx-summary-title">RESUMEN CLINICO DEL PACIENTE</div>
              <div class="rx-summary-sub">
                REVISA ANTECEDENTES Y MEDICACION ACTIVA ANTES DE PRESCRIBIR.
              </div>
            </div>

            <div class="rx-summary-grid">

              <!-- =========================
                   ANTECEDENTES CRONICOS
              ========================== -->
              <div class="rx-card">
                <div class="rx-card-head">
                  <div class="rx-card-head-left">
                    <span class="rx-card-head-accent"></span>
                    <mat-icon class="rx-card-head-icon">medical_information</mat-icon>
                    <span class="rx-card-head-text">ANTECEDENTES CRONICOS</span>
                  </div>

                  <span class="rx-counter" *ngIf="(patientHistoryDataSource.getValue()?.length ?? 0) > 0">
                    {{ patientHistoryDataSource.getValue().length }}
                  </span>
                </div>

                @if (patientHistoryDataSource.getValue().length === 0) {
                  <div class="rx-empty">
                    <mat-icon class="rx-empty-icon">info</mat-icon>
                    <span>NO HAY ANTECEDENTES CRONICOS REGISTRADOS.</span>
                  </div>
                } @else {
                  <div class="rx-list">
                    @for (row of patientHistoryDataSource.getValue(); track row) {
                      <div class="rx-item">
                        <div class="rx-item-title">{{ row.detailTypeName }}</div>

                        <div class="rx-item-meta">
                          <span class="rx-pill rx-pill-muted">
                            {{ (row.detailType).toString().toUpperCase() }}
                          </span>

                          @if (row.detailTypeCode) {
                            <span class="rx-pill">
                              <mat-icon class="rx-pill-icon">qr_code_2</mat-icon>
                              <span>CODIGO:</span>
                              <strong>{{ row.detailTypeCode }}</strong>
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- =========================
                   MEDICAMENTOS ACTIVOS
              ========================== -->
              <div class="rx-card">

                <!-- HEADER -->
                <div class="rx-card-head">
                  <div class="rx-card-head-left">
                    <span class="rx-card-head-accent"></span>
                    <mat-icon class="rx-card-head-icon">medication</mat-icon>
                    <span class="rx-card-head-text">MEDICAMENTOS ACTIVOS</span>
                  </div>

                  <span class="rx-counter" *ngIf="(medicamentosActivosPaciente?.length ?? 0) > 0">
                    {{ medicamentosActivosPaciente.length }}
                  </span>
                </div>

                <!-- ✅ LEYENDA Y BOTON SI HAY OCULTOS -->
                @if (hasHiddenMeds  && !showHiddenMeds) {
                  <div class="rx-hidden-banner">
                    <div class="rx-hidden-text">
                      <mat-icon class="rx-hidden-icon">visibility_off</mat-icon>
                      <span>EL PACIENTE TIENE MEDICAMENTOS OCULTOS</span>
                    </div>

                    <button
                      mat-stroked-button
                      color="primary"
                      type="button"
                      (click)="toggleMedicamentosOcultos()">

                      <mat-icon>
                        {{ showHiddenMeds ? 'visibility_off' : 'visibility' }}
                      </mat-icon>

                      {{ showHiddenMeds
                      ? 'OCULTAR MEDICAMENTOS OCULTOS'
                      : 'MOSTRAR MEDICAMENTOS OCULTOS' }}
                    </button>
                  </div>
                }

                <!-- CONTENIDO -->
                @if (isLoadingMedsActivos) {

                  <div class="rx-empty">
                    <mat-icon class="rx-empty-icon">hourglass_top</mat-icon>
                    <span>CARGANDO MEDICAMENTOS ACTIVOS...</span>
                  </div>

                } @else {

                  @if (medicamentosActivosPaciente.length === 0) {

                    <div class="rx-empty">
                      <mat-icon class="rx-empty-icon">info</mat-icon>
                      <span>NO HAY MEDICAMENTOS ACTIVOS REGISTRADOS.</span>
                    </div>

                  } @else {

                    <div class="rx-list">
                      @for (m of medicamentosActivosPaciente; track m) {
                        <div
                          class="rx-item"
                          [class.rx-item-hidden]="m.hide && !showHiddenMeds">

                          <div class="rx-item-title">

                            <!-- 🔒 Si está oculto y NO se ha ingresado PIN -->
                            @if (m.hide && !showHiddenMeds) {
                              <mat-icon class="rx-lock-icon">lock</mat-icon>
                              <span class="rx-hidden-text-item">
                                MEDICAMENTO OCULTO
                              </span>
                            } @else {

                              <!-- ✅ Nombre normal -->
                              <span>{{ m.medicamento }}</span>
                            }
                          </div>

                          <!-- Meta se muestra cuando no está bloqueado -->
                          @if (!(m.hide && !showHiddenMeds)) {
                            <div class="rx-item-meta">

                              <span class="rx-pill">
                                <mat-icon class="rx-pill-icon">inventory_2</mat-icon>
                                <strong>{{ m.drugType | medicamentoTypeLabel }}</strong>
                              </span>

                              <span class="rx-pill rx-pill-muted">
                                <mat-icon class="rx-pill-icon">event</mat-icon>
                                <span>FECHA:</span>
                                <strong>{{ formatFechaCorta(m.fechaCreacion) }}</strong>
                              </span>

                              @if (m.hide) {
                                <span class="rx-badge-hidden">
                                  <mat-icon class="rx-badge-hidden-icon">visibility_off</mat-icon>
                                  OCULTO
                                </span>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      </mat-expansion-panel>
      <br>

      <form [formGroup]="prescriptionForm" class="register-form">
        <mat-expansion-panel #panelConsulta="matExpansionPanel" *ngIf="isPatientLoaded" data-tour="rx-panel-consulta">
          <mat-expansion-panel-header>
            <mat-panel-title>
              DATOS DE CONSULTA
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="header">
            <p style="color: #1d2671; font-weight: bold">PERFIL DE PACIENTE</p>
          </div>
          <mat-divider/>
          <br>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>GENERO</mat-label>
                <mat-select (selectionChange)="onGenderChange($event.value)" formControlName="gender" required data-tour="rx-gender">
                  <mat-option value="F">FEMENINO</mat-option>
                  <mat-option value="M">MASCULINO</mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="prescriptionForm.get('gender')?.touched && prescriptionForm.get('gender')?.hasError('required')"
                   class="custom-error-below">
                <small class="text-danger">{{ getErrorMessage() }}</small>
              </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>EDAD</mat-label>
                <input
                  aria-autocomplete="none"
                  autocomplete="nope"
                  formControlName="age"
                  matInput
                  type="text"
                  readonly
                />
              </mat-form-field>
              <div *ngIf="prescriptionForm.get('age')?.touched && prescriptionForm.get('age')?.hasError('required')"
                   class="custom-error-below">
                <small class="text-danger">{{ getErrorMessage() }}</small>
              </div>

            </div>

            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>PESO</mat-label>
                <input
                  aria-autocomplete="none"
                  autocomplete="nope"
                  formControlName="weight"
                  matInput
                  required
                  type="number"
                  data-tour="rx-weight"
                />
                <span matSuffix>KG &nbsp;</span>
              </mat-form-field>
              <div *ngIf="prescriptionForm.get('weight')?.touched && prescriptionForm.get('weight')?.hasError('required')"
                   class="custom-error-below">
                <small class="text-danger">{{ getErrorMessage() }}</small>
              </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>ALTURA</mat-label>
                <input
                  aria-autocomplete="none"
                  autocomplete="nope"
                  formControlName="height"
                  matInput
                  required
                  type="number"
                  data-tour="rx-height"
                />
                <span matSuffix>CM &nbsp;</span>
              </mat-form-field>
              <div *ngIf="prescriptionForm.get('height')?.touched && prescriptionForm.get('height')?.hasError('required')"
                   class="custom-error-below">
                <small class="text-danger">{{ getErrorMessage() }}</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>ACLARAMIENTO CREATININA</mat-label>
                <input
                  aria-autocomplete="none"
                  autocomplete="nope"
                  formControlName="creatin"
                  matInput
                  type="number"
                />
                <span matSuffix>ML/MIN &nbsp;</span>
              </mat-form-field>
              <div *ngIf="prescriptionForm.get('creatin')?.touched && prescriptionForm.get('creatin')?.hasError('required')"
                   class="custom-error-below">
                <small class="text-danger">{{ getErrorMessage() }}</small>
              </div>
            </div>

            <div [hidden]="!isPregnant" class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>AMENORREA</mat-label>
                <input
                  [min]="prescriptionForm.get('pregnancy')?.value ? 1 : null"
                  aria-autocomplete="none"
                  autocomplete="nope"
                  formControlName="weeksOfAmenorrhea"
                  matInput
                  required
                  type="number"
                />
                <span matSuffix>SEMANAS &nbsp;</span>
              </mat-form-field>
              <div *ngIf="prescriptionForm.get('weeksOfAmenorrhea')?.touched && prescriptionForm.get('weeksOfAmenorrhea')?.hasError('required')"
                   class="custom-error-below">
                <small class="text-danger">{{ getErrorMessage() }}</small>
              </div>
            </div>

            <div [hidden]="isGenderRestricted" class="col-lg-3 col-md-3 col-sm-12 col-xs-12 checkbox-container">
              <mat-checkbox class="custom-checkbox" formControlName="pregnancy">
                EMBARAZO
              </mat-checkbox>
              <mat-checkbox
                (change)="onBreastFeedingChange($event)"
                [checked]="prescriptionForm.get('breastFeeding')?.value === 'ALL'"
                [hidden]="isGenderRestricted"
                class="custom-checkbox"
                formControlName="breastFeeding">
                LACTANCIA
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
        <br>

        <mat-expansion-panel #panelDiagnostico="matExpansionPanel" *ngIf="isPatientLoaded" data-tour="rx-panel-diagnostico">
        <mat-expansion-panel-header>
          <mat-panel-title>
            DIAGNOSTICO
          </mat-panel-title>
        </mat-expansion-panel-header>

        @if (!canUseDiagnosticsSearch) {
          <div class="rx-validation-note">
            <mat-icon>info</mat-icon>
            <span>{{ diagnosticsLockMessage }}</span>
          </div>
        }

        <div class="row mt-3">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>BUSCAR PATOLOGIA</mat-label>
                    <input
                      (input)="searchPatologiesByKeyPress()"
                      (focus)="clearPatologies()"
                      (click)="clearPatologies()"
                      [matAutocomplete]="autoPatologies"
                      aria-autocomplete="none"
                  autocomplete="nope"
                  formControlName="searchPatologies"
                  matInput
                  type="text"
                  data-tour="rx-search-patologias"
                />
                    <mat-autocomplete
                      #autoPatologies="matAutocomplete"
                      (optionSelected)="setSelectedPatology($event.option.value)"
                      [displayWith]="displayFnPatologies"
                    >
                      @for (option of patologies; track option) {
                        <mat-option [value]="option">
                          {{ option.nameCIM10 }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>

                  @if (shouldShowChronicFollowupImport && chronicFollowupAvailable > 0) {
                    <div class="rx-chronic-followup">
                      <button
                        mat-stroked-button
                        color="primary"
                        type="button"
                        class="rx-chronic-followup-btn"
                        (click)="importChronicPathologiesToDiagnosis()">
                        <mat-icon>playlist_add_check</mat-icon>
                        SEGUIMIENTO A PADECIMIENTOS CRONICOS
                        <span class="rx-chronic-followup-count">{{ chronicFollowupAvailable }}</span>
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>BUSCAR ALERGIA</mat-label>
                    <input
                      (input)="searchAllergiesByKeyPress()"
                      (focus)="clearAlergies()"
                      (click)="clearAlergies()"
                      [matAutocomplete]="autoAlergias"
                      aria-autocomplete="none"
                      autocomplete="nope"
                  formControlName="searchAllergies"
                  matInput
                  name="allergies"
                  type="text"
                  data-tour="rx-search-alergias"
                />
                    <mat-autocomplete
                      #autoAlergias="matAutocomplete"
                      (optionSelected)="setSelectedAllergy($event.option.value)"
                      [displayWith]="displayFnAllergy"
                    >
                      @for (option of allergies; track option) {
                        <mat-option [value]="option">
                          {{ option.nameAllergy }}
                        </mat-option>
                      }
                      @for (option of molescules; track option) {
                        <mat-option [value]="option">
                          {{ option.nameMolecule }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <mat-checkbox (change)="clearAlergies()" formControlName="searchAllergiesChecked">ALERGIA
                  </mat-checkbox>
                  <mat-checkbox (change)="clearAlergies()" formControlName="searchMoleculesChecked">MOLECULA
                  </mat-checkbox>
                </div>
              </div>
            </div>
            @if (patientDataSource.getValue().length > 0) {
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="card">
                    <div class="body overflow-auto">
                      <div class="responsive_table">
                        <table [dataSource]="patientDataSource" class="mat-cell advance-table" mat-table
                               matSort>

                          <ng-container matColumnDef="tipo">
                            <mat-header-cell *matHeaderCellDef> TIPO</mat-header-cell>
                            <mat-cell *matCellDef="let row" matTooltip="{{row.drugType}}">
                              <span class="mobile-label">Tipo</span>
                              {{ row.detailType }}
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="nombre">
                            <mat-header-cell *matHeaderCellDef> NOMBRE</mat-header-cell>
                            <mat-cell *matCellDef="let row" matTooltip="{{row.drug}}">
                              <span class="mobile-label">Nombre</span>
                              {{ row.detailTypeName }}
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="cronico">
                            <mat-header-cell *matHeaderCellDef> CRONICO?</mat-header-cell>
                            <mat-cell *matCellDef="let row">
                              <mat-checkbox (click)="$event.stopPropagation()"
                                            (change)="$event ? selection.toggle(row) : null"
                                            [checked]="selection.isSelected(row)" [ngClass]="'tbl-checkbox'">
                              </mat-checkbox>
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="idCode">
                            <mat-header-cell *matHeaderCellDef> CODIGO</mat-header-cell>
                            <mat-cell *matCellDef="let row" matTooltip="{{row.unitId}}">
                              <span class="mobile-label">Codigo / Id</span>
                              {{ row.detailTypeCode }}
                            </mat-cell>
                          </ng-container>

                          <ng-container matColumnDef="acciones">
                            <mat-header-cell *matHeaderCellDef class="pr-0">ACCIONES</mat-header-cell>
                            <mat-cell *matCellDef="let row; let i=index;" class="pr-0">
                              <button (click)="$event.stopPropagation(); deletePatientLine(i)" class="tbl-action-btn" mat-icon-button>
                                <app-feather-icons [class]="'tbl-fav-delete'" [icon]="'trash-2'"></app-feather-icons>
                              </button>
                            </mat-cell>
                          </ng-container>

                          <mat-header-row *matHeaderRowDef="displayedColumnsPatients"></mat-header-row>
                          <mat-row *matRowDef="let row; columns: displayedColumnsPatients;" matRipple></mat-row>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </mat-expansion-panel>
        <br>

        <mat-expansion-panel #panelMedicamentos="matExpansionPanel"
                             *ngIf="isPatientLoaded"
                             data-tour="rx-panel-meds">
        <mat-expansion-panel-header>
          <mat-panel-title>
            MEDICAMENTOS
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (isPatientLoaded) {
          @if (!canUseMedicationSearch) {
            <div class="rx-validation-note">
              <mat-icon>info</mat-icon>
              <span>{{ medicationLockMessage }}</span>
            </div>
          }

          <div class="row mt-3">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>BUSCAR MEDICAMENTOS</mat-label>
                      <input
                        autocomplete="nope"
                        aria-autocomplete="none"
                        (input)="searchMedicamentsByKeyPress()"
                        (focus)="clearMedicaments()"
                        (click)="clearMedicaments()"
                        (keydown.enter)="onEnterMedicaments($event)"
                    [matAutocomplete]="autoMedicaments"
                    formControlName="searchMedicaments"
                    matInput
                    name="medicaments"
                    [disabled]="!canUseMedicationSearch"
                    type="text"
                    data-tour="rx-search-medicamentos"
                  />

                      <button mat-icon-button matSuffix
                           type="button"
                           aria-label="Agregar medicamento libre"
                           *ngIf="canUseMedicationSearch && (medicaments?.length ?? 0) === 0 && prescriptionForm.get('searchMedicaments')?.value"
                           (click)="addFreeMedicament()" data-tour="rx-add-free-med">
                        <mat-icon>add_circle</mat-icon>
                      </button>

                      <mat-autocomplete
                        #autoMedicaments="matAutocomplete"
                        (optionSelected)="setSelectedMedicamente($event.option.value)"
                        [displayWith]="displayFnMedicaments"
                      >
                        @for (option of medicaments; track option) {
                          <mat-option [value]="option">
                            {{ option.summary }}
                          </mat-option>
                        }
                      </mat-autocomplete>

                      <!-- ✅ Hint cuando no hay opciones -->
                      <mat-hint *ngIf="(medicaments?.length ?? 0) === 0 && prescriptionForm.get('searchMedicaments')?.value">
                        PRESIONA ENTER PARA AGREGAR MEDICAMENTO.
                      </mat-hint>
                    </mat-form-field>

                  </div>
                  <p class="border-botton"></p>
                </div>
              </div>

              @if (prescriptionDataSource.getValue().length > 0) {
                <div class="parafarmacia-legend" *ngIf="hasParafarmacia()">
                  <mat-icon>info</mat-icon>
                  <span>LOS PRODUCTOS DE PARAFARMACIA NO SE INCLUIRAN EN EL ANALISIS DE VADEMECUM.</span>
                </div>

                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                      <div class="body">
                        <div class="medicamentos-list">

                          <div
                            class="med-card"
                            *ngFor="let row of prescriptionDataSource.getValue(); let i = index"
                            [class.med-card-hidden]="row?.hide"
                          >
                            <!-- FILA SUPERIOR -->
                            <div class="med-card-top">
                              <div class="med-card-type">
                                <div class="med-card-label">TIPO</div>
                                <div class="med-card-value med-type-badge"
                                     [ngClass]="{
                                       'badge-producto': row.drugType === 'PRODUCT',
                                       'badge-parafarmacia': row.drugType === 'PARAFARMACIA'
                                     }">
                                  {{ row.drugType | medicamentoTypeLabel }}
                                </div>
                              </div>

                              <div class="med-card-drug" [matTooltip]="row.summary">
                                <div class="med-card-label">MEDICAMENTO</div>
                                <div class="med-card-drug-name">
                                  {{ row.summary }}
                                </div>
                              </div>
                            </div>

                            <!-- FILA INFERIOR -->
                            <div class="med-card-bottom">
                              <div class="med-card-item">
                                <div class="med-card-label">DOSIS</div>
                                <div class="med-card-value">
                                  {{ row.dose || '-' }} {{ row.unitIdName || '' }}
                                </div>
                              </div>

                              <div class="med-card-item">
                                <div class="med-card-label">FRECUENCIA</div>
                                <div class="med-card-value">
                                  {{ row.frecuency ? ('CADA ' + row.frecuency + ' ' + (row.frecuencyType || '')) : '-' }}
                                </div>
                              </div>

                              <div class="med-card-item">
                                <div class="med-card-label">DURACION</div>
                                <div class="med-card-value">
                                  {{ row.duration ? (row.duration + ' ' + (row.durationName || '')) : '-' }}
                                </div>
                              </div>

                              <div class="med-card-item">
                                <div class="med-card-label">VIA</div>
                                <div class="med-card-value">
                                  {{ row.routeName || '-' }}
                                </div>
                              </div>

                              <div class="med-card-item">
                                <div class="med-card-label">MOTIVO</div>
                                <div class="med-card-value">
                                  {{ row.indicationName || '-' }}
                                </div>
                              </div>

                              <div class="med-card-item">
                                <div class="med-card-label">INDICACIONES</div>
                                <div class="med-card-value">
                                  {{ row.obs || '-' }}
                                </div>
                              </div>

                              <div class="med-card-actions">
                                <div class="med-card-label">ACCIONES</div>

                                <div class="med-card-actions-row">
                                  <button
                                    mat-icon-button
                                    color="primary"
                                    *ngIf="row.drug && row.drug !== '0'"
                                    (click)="openMedicamentoDocuments(row)"
                                    matTooltip="DOCUMENTOS"
                                    type="button"
                                  >
                                    <mat-icon>description</mat-icon>
                                  </button>

                                  <button
                                    mat-icon-button
                                    type="button"
                                    (click)="$event.stopPropagation(); toggleHideRow(i, row)"
                                    [matTooltip]="row?.hide ? 'MOSTRAR' : 'OCULTAR'"
                                    aria-label="Ocultar/Mostrar medicamento"
                                  >
                                    <mat-icon>{{ row?.hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                  </button>

                                  <button
                                    mat-icon-button
                                    type="button"
                                    class="tbl-action-btn"
                                    data-tour="rx-edit-line"
                                    (click)="$event.stopPropagation(); updateLine(row, i)"
                                    matTooltip="EDITAR"
                                  >
                                    <app-feather-icons
                                      [class]="'tbl-fav-edit'"
                                      [icon]="'edit-2'"
                                    ></app-feather-icons>
                                  </button>

                                  <button
                                    mat-icon-button
                                    type="button"
                                    class="tbl-action-btn"
                                    (click)="$event.stopPropagation(); deleteLine(i)"
                                    matTooltip="ELIMINAR"
                                  >
                                    <app-feather-icons
                                      [class]="'tbl-fav-delete'"
                                      [icon]="'trash-2'"
                                    ></app-feather-icons>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
      </form>
      <br>

      <div #validationBanner
           *ngIf="hasTriedSave && globalErrors.length"
           style="background:#fff3cd;border:1px solid #ffeeba;color:#856404;border-radius:8px;padding:14px 16px;margin:18px 0;">
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
          <mat-icon style="color:#e0a800;">warning</mat-icon>
          <strong>FALTAN CAMPOS OBLIGATORIOS</strong>
        </div>
        <ul style="margin:0 0 0 18px;padding:0;">
          <li *ngFor="let e of globalErrors" style="margin-bottom:4px;">{{ e }}</li>
        </ul>
      </div>


      <mat-expansion-panel [ngClass]="{ 'alerta-activa': alertasControl > 0 }" *ngIf="isPatientLoaded">
        <mat-expansion-panel-header>
          <mat-panel-title>ALERTAS</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row align-items-center alerta-distribuida">
          <!-- Columna: Texto izquierda -->
          <div class="col-md-2 col-12 text-center">
            <strong *ngIf="alertasControl > 0">
              ALERTAS DE RIESGO CRITICO ({{ alertasControl }})
            </strong>
            <strong *ngIf="alertasControl === 0" style="color: #999;">
              SIN ALERTAS CRITICAS
            </strong><br />
            <span class="subtitulo-alerta" *ngIf="alertasControl > 1">
              OTRAS ALERTAS ({{ alertasControl - 1 }})
            </span>
          </div>

          <!-- Columna: Botones -->
          <div class="col-md-10 col-12">
            <!-- FILA 1 -->
            <div class="row g-2">
              <div class="col-md-6 col-12">
                <button mat-raised-button class="btn-ver-alertas w-100"
                        [disabled]="alertasControl === 0"
                        [ngClass]="alertasControl === 0 ? 'btn-alerta-inactiva' : 'btn-ver-alertas'"
                        (click)="openPrescriptionLineModal()">
                  <mat-icon class="icono-blanco">visibility</mat-icon>
                  VER ADVERTENCIAS CRITICAS
                </button>
              </div>

              <div class="col-md-6 col-12">
                <button mat-stroked-button color="primary" class="btn-vademecum w-100"
                        (click)="confirmAdd(1)">
                  <mat-icon class="icono-accion">visibility</mat-icon>
                  <img src="assets/images/logo_vidal.png" alt="VIDAL" class="logo-vidal" />
                  VER ANALISIS VADEMECUM
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <br>
      @if (isPatientLoaded) {
        <div class="row" style="margin-top: 2em">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <button
              data-tour="rx-save"
              (click)="onSubmit()"
              color="warn"
              mat-raised-button
              [disabled]="hasTriedSave && !isGloballyValid">
              {{ isEditMode ? 'ACTUALIZAR RECETA' : 'GUARDAR RECETA' }}
            </button>

          </div>
        </div>

      }

    </mat-accordion>
  </div>
</section>
